import { yieldToEventLoop } from '../../../../runtime/yield-to-event-loop.js';
import { HYDRATE_YIELD_EVERY_LINES } from './constants.js';

export function createHydrateYield(): () => Promise<void> {
  let processedLines = 0;
  return async (): Promise<void> => {
    processedLines++;
    if (processedLines % HYDRATE_YIELD_EVERY_LINES === 0) {
      await yieldToEventLoop();
    }
  };
}
